/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { ErrorMessage, Field, Formik } from "formik";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {
  createValidationPolicyYupSchema,
  useValidationService
} from "../../../resources/validations/validations";
import { useGeneralService } from "../../../services/generalService";
import { useSafetyService } from "../../../services/safetyService.js"

/* Components */
import UCSelect from "../../../components/ucselect"

/* Styles */
import styles from "./styles.js"
import {colors} from "../../../constants/colors";


const messages = defineMessages({
  emailPlaceholderMessage: {
    id: 'safetyInviteGuest.email'
  },
})

const Content = props => {
  const { setShowModal, handleSubmit, teams, defaultTeam } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const formRef = useRef(null);
  const intl = useIntl();

  const { inviteGuestMockedApiValidationObj } = useValidationService()
  const [testSchema, setTestSchema] = useState({});
  const [emailExistsInCompany, setEmailExistsInCompany] = useState(false);
  const [previousEmail, setPreviousEmail] = useState("");

  const { checkIfEmailExists } = useSafetyService();

  useEffect(() => {
    //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(inviteGuestMockedApiValidationObj);
    setTestSchema(result)
  }, [])

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }
  const checkEmailInput = (values) => {
    if(emailExistsInCompany) {
      if(values.emailAddress !== previousEmail) {
        setEmailExistsInCompany(false)
      }
    }
  }

  const submitForm = async (values) => {
    const response = await checkIfEmailExists({emailAddress: values?.emailAddress})
    if (response?.emailExistsInCompany) {
      setEmailExistsInCompany(true)
      setPreviousEmail(values?.emailAddress)
    } else {
      setEmailExistsInCompany(false)
      setPreviousEmail("")
      await handleSubmit({
        groupEntityId: values?.groupId,
        emailAddresses: [values?.emailAddress],
      })
    }    
  }

  return (
    <div className={classes.modalContent}>
      {
        teams && defaultTeam?.groupEntityId &&    
        <Formik
          innerRef={formRef}
          initialValues={{         
            groupId: defaultTeam?.groupEntityId,
            emailAddress: "",
          }}
          validationSchema={testSchema}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            submitForm(values, setSubmitting, setErrors);
          }}
        >
          {({
            values,
            errors,
            touched,
            setFieldTouched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
              setFieldValue
            }) => (

            <>
              <form onSubmit={handleSubmit} onChange={checkEmailInput(values)}>
                <div className={classes.inputContainer}>
                  <label htmlFor="emailAddress" className={classes.label}>
                    <FormattedMessage id="safetyInviteGuest.email"/>
                  </label>
                  <Field
                    placeholder={intl.formatMessage(messages.emailPlaceholderMessage)}
                    type="text"
                    name="emailAddress"
                    id="emailAddress"
                    className={
                      (errors.emailAddress && touched.emailAddress) || emailExistsInCompany
                        ? "input-error"
                        : null
                    }
                  />
                  {
                    emailExistsInCompany ? 
                      <div className={classes.error}>
                        <FormattedMessage id="safetyInviteGuest.emailAlreadyExists" />
                      </div>
                    :
                      <ErrorMessage
                        name="emailAddress"
                        component="span"
                        className={classes.error}
                      />
                  }                  
                </div>
                
                <div className={classes.inputContainer}>
                  <label htmlFor="status" className={classes.label}>
                    <FormattedMessage id="safetyInviteGuest.team"/>
                  </label>
                  {
                    teams.length > 0 &&
                    <Field
                      type="select"
                      name="groupId"
                      id="groupId"
                      render={({ form }) => (
                        <div>
                          <UCSelect
                            className={classes.roles}
                            displayName={<FormattedMessage id="people.allTeams" />}
                            options={teams}
                            defaultValue={teams.find(item => item.default === true)}
                            onChange={(item) => form.setFieldValue("groupId", item.groupEntityId)}
                            getOptionLabel={option => option.groupName}
                            getOptionValue={option => option.groupEntityId}
                          />
                          <ErrorMessage
                            name="groupId"
                            component="span"
                            className={classes.error}
                          />
                        </div>
                      )}
                    />
                  }
                </div>
                <div className={classes.btnContainer}>
                  <ContainerFluid>
                    <Row>
                      <Col className={classes.colCancel}>
                        <UCButton
                          onClick={() => setShowModal(false)}
                          type="default"
                          className={classes.btnStyle}
                          text={<FormattedMessage id="safetyInviteGuest.cancel"/>}
                        />
                      </Col>
                      <Col className={classes.colRemove} >
                        <UCButton
                          className={classes.btnStyle}
                          onClick={handleFormSubmit}
                          type="primary"
                          text={<FormattedMessage id="safetyInviteGuest.send"/>}
                          disabled={!values.emailAddress || !values.groupId}
                          spinner={{
                            name: "inviteGuestSpinner",
                            size: 20,
                          }}
                        />
                      </Col>
                    </Row>
                  </ContainerFluid>
                </div>
              </form>
            </>
          )}
        </Formik>
      }
    </div>
  )
}

export default Content;
